export default __webpack_public_path__ + "static/media/veechat.27c69fbe.png";